module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_03@2x-069bad8eae72908d98977c5723a1622e.jpg";